import { useQueryClient } from '@tanstack/react-query';
import { useClient } from 'hooks/useClient';
import { useExperiment } from './useExperiment';

export const useCookieTargeting = (experimentId: number) => {
  const { experiment } = useExperiment(experimentId);
  const queryClient = useQueryClient();
  const apiClient = useClient();

  const deleteCookieTargeting = async (id: number) => {
    await apiClient.delete(`/cookie-targeting/${id}?experimentId=${experimentId}`);
    queryClient.invalidateQueries({ queryKey: ['EXPERIMENT', experimentId] });
  };

  const addCookieTargeting = async (payload: any) => {
    await apiClient.post(`/cookie-targeting`, { ...payload, experimentId });
    queryClient.invalidateQueries({ queryKey: ['EXPERIMENT', experimentId] });
  };

  return {
    cookieTargeting: experiment?.cookieTargeting,
    addCookieTargeting,
    deleteCookieTargeting,
  };
};
